import {
  productOne,
  productTwo,
  productThree,
  productFour,
  productFive,
  productSix,
  productSeven,
  productEight,
  productNine,
  productTen,
  productEleven,
  productTwelve,
  productThirdteen,
  productFourteen,
  productFifthteen,
  productSixteen,
} from "../../products/productData";
import Product from "../../products/Product";
export const slideProductData = [
  { case: <Product {...productOne} /> },
  { case: <Product {...productTwo} /> },
  { case: <Product {...productThree} /> },
  { case: <Product {...productFour} /> },
  { case: <Product {...productFive} /> },
  { case: <Product {...productSix} /> },
  { case: <Product {...productSeven} /> },
  { case: <Product {...productEight} /> },
  { case: <Product {...productNine} /> },
  { case: <Product {...productTen} /> },
  { case: <Product {...productEleven} /> },
  { case: <Product {...productTwelve} /> },
  { case: <Product {...productThirdteen} /> },
  { case: <Product {...productFourteen} /> },
  { case: <Product {...productFifthteen} /> },
  { case: <Product {...productSixteen} /> },
];
